'use client';

import { ReactNode, useEffect, useRef } from 'react';

import './FocusTrap.scss';

export const FocusTrap = ({ children }: { children: ReactNode }) => {
  const TrapRef = useRef<HTMLDivElement>(null);
  const topAnchorRef = useRef<HTMLButtonElement>(null);
  const bottomAnchorRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const trap = TrapRef?.current as HTMLElement;
    const topAnchor = topAnchorRef?.current;
    const bottomAnchor = bottomAnchorRef?.current;

    const focusableElements = trap?.querySelectorAll(
      ':not([disabled]):is(button, [href], input, select, textarea,[tabindex]:not([tabindex="-1"]))',
    );

    let onTopFocus: () => void = () => {};
    let onBottomFocus: () => void = () => {};

    if (focusableElements?.length && topAnchor && bottomAnchor) {
      const firstElement = focusableElements[0] as HTMLElement;
      const lastElement = focusableElements[
        focusableElements.length - 1
      ] as HTMLElement;

      onTopFocus = () => {
        lastElement.focus();
      };
      onBottomFocus = () => {
        firstElement.focus();
      };

      topAnchor.addEventListener('focus', onTopFocus);
      bottomAnchor.addEventListener('focus', onBottomFocus);

      firstElement.focus();
    }

    return () => {
      topAnchor?.removeEventListener('focus', onTopFocus);
      bottomAnchor?.removeEventListener('focus', onBottomFocus);
    };
  }, [topAnchorRef, bottomAnchorRef, TrapRef]);

  return (
    <>
      <button className='focus-trap-anchor' ref={topAnchorRef} type='button'>
        ↓
      </button>
      <div className='focus-trap-content' ref={TrapRef}>
        {children}
      </div>
      <button className='focus-trap-anchor' ref={bottomAnchorRef} type='button'>
        ↑
      </button>
    </>
  );
};

export default FocusTrap;
